let selectEl;
let infoEl;
let titleEl;
let contentEl;

const settings = {
    container: "[data-clinic]",
    slctrInfo: "[data-clinic-info]",
    slctrTitle: "[data-clinic-title]",
    slctrContent: "[data-clinic-content]",
};

const hideClinicInfo = () => {
    infoEl.classList.add("hidden");
};

const showClinicInfo = () => {
    infoEl.classList.remove("hidden");
};

const setClinicInfo = (title, content) => {
    titleEl.textContent = title;
    contentEl.textContent = content;
};

const populateClinicInfo = (el) => {
    const selectedOption = el.options[el.selectedIndex].value;
    if (selectedOption in window.CLINICS && window.CLINICS[selectedOption].content) {
        showClinicInfo();
        setClinicInfo(
            `${window.CLINICS[selectedOption].name} Opening Times`,
            window.CLINICS[selectedOption].content,
        )
    } else {
        hideClinicInfo();
    }
}

const ClinicOpeningTimes = () => {
    selectEl = document.querySelector(settings.container);
    if (selectEl === null) {
        return;
    }
    infoEl = document.querySelector(settings.slctrInfo);
    titleEl = infoEl.querySelector(settings.slctrTitle);
    contentEl = infoEl.querySelector(settings.slctrContent);
    selectEl.addEventListener("change", (event) => {
        populateClinicInfo(event.target);
    });
    populateClinicInfo(selectEl);
};

export default ClinicOpeningTimes;
